import React from 'react'

function Header() {
  return (
      <header className="header">
        <h1 className="header__title">Craftlist</h1>
        <p className="header__subtitle">Make your own shopping list when you are feeling like crafting!</p>
      </header>
  )
}

export default Header
